import LinkButton, { LinkButtonProps } from './LinkButton';

export { LinkButtonProps };
export default LinkButton;
